import React from 'react';

const DateFilter = ({ startDate, endDate, onStartDateChange, onEndDateChange, count }) => (
  <div className="bg-white border border-gray-200 rounded p-4">
    <div className="flex items-center gap-4 flex-wrap">
      <div className="flex items-center gap-2">
        <label className="text-sm font-medium text-gray-900">From:</label>
        <input
          type="date"
          value={startDate}
          onChange={onStartDateChange}
          className="bg-white border border-gray-200 rounded px-3 py-2 text-sm text-gray-900"
        />
      </div>
      <div className="flex items-center gap-2">
        <label className="text-sm font-medium text-gray-900">To:</label>
        <input
          type="date"
          value={endDate}
          onChange={onEndDateChange}
          className="bg-white border border-gray-200 rounded px-3 py-2 text-sm text-gray-900"
        />
      </div>
      <div className="text-sm text-gray-600">
        Showing {count} SMS conversations
      </div>
    </div>
  </div>
);

export default DateFilter;